export default "__VITE_ASSET__Ca4ZV3m3__"